import { isNil } from 'lodash/fp'
import log from 'loglevel'
import { type AuthProvider } from 'react-admin'
import axios from 'axios'

const env = process.env['ENV'] as string
log.setLevel(log.levels[process.env['LOG_LEVEL'] as string] ?? log.levels.DEBUG)

const accessTokenKey = 'token'
const apiDomain = !isNil(process.env['API_LOCAL'])
  ? 'http://localhost:14001/v1'
  : ({
      prd: 'https://response-form.ops.terashite.jp/v1',
      stg: 'https://response-form-stg.ops.terashite.jp/v1',
      exp: 'https://response-form-exp.ops.dev.terashite.jp/v1',
      dev: 'https://response-form.ops.dev.terashite.jp/v1'
    }[env] as string)

export const tokenAuthProvider: AuthProvider = {
  async login(params: {
    id: string
    otp: string
  }): Promise<{ redirectTo?: string | boolean } | void | any> {
    const { id, otp } = params
    const res = await axios
      .post(`${apiDomain}/password`, { id, otp })
      .catch(async (error) => {
        log.error(`[Auth.login]`, error)
        return await Promise.reject()
      })
    if (isNil(res) || isNil(res.data)) {
      log.error(`[Auth.login] response error`)
      return await Promise.reject()
    }
    const { token } = res.data
    if (isNil(token)) {
      log.error(`[Auth.login] invalid request`)
      return await Promise.reject()
    }
    localStorage.setItem(accessTokenKey, token)
    await Promise.resolve()
  },
  async logout(): Promise<void | false | string> {
    localStorage.removeItem(accessTokenKey)
  },
  async checkAuth(): Promise<void> {
    const accessToken = localStorage.getItem(accessTokenKey)
    !isNil(accessToken) ? await Promise.resolve() : await Promise.reject()
  },
  async checkError(error: any): Promise<void> {
    const { status } = error
    if (status === 401 || status === 403) {
      localStorage.removeItem(accessTokenKey)
    }
    await Promise.reject({
      messages: '再度ログインしてください。'
    })
  },
  async getPermissions(): Promise<void> {
    await Promise.resolve()
  }
}
